<template>
   <div>
      <ddoSelect :callbacks="callbacks" ref="mySelectMPR" :options="options">
         <template v-slot:selection="data">
            <v-chip
               v-bind="data.attrs"
               :input-value="data.selected"
            >
               <span v-text="data.item.mpr_name"></span>
            </v-chip>
         </template>

         <template v-slot:item="data">
            <v-list-item-content>
               <v-list-item-title v-html="data.item.mpr_name"></v-list-item-title>
               <v-list-item-subtitle v-html="data.item.mpr_code"></v-list-item-subtitle>
            </v-list-item-content>
         </template>
      </ddoSelect>
    </div> 
</template>

<script>
import ddoSelect from '@/components/ddoSelect.vue';

export default {
   name: 'ddoSelectMailprofile',
   mixins: [ddoSelect],

   components: {
      ddoSelect
   },

   async mounted() {
      if ( !this.callbacks.refresh_rows ) {
         this.callbacks.refresh_rows = this.build_select_mpr;
      }
   },

   methods: {

      async build_select_mpr(key=null) {
         console.log('build_select_mpr');
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'mailprofile');
         this.$emit('loading',false);
         return { errorinfos, api_response }
      },

   },

}
</script>